import * as React from 'react';
import { translate } from '../translate-hoc';

import { ILoginSession } from 'types/session';
import { ITranslationProps } from 'types/translation';
import IConfig from '@sitegen/common/constants/config';
import { IWindowWithOverlay } from 'modules/ubisoft-overlay-service/types';

import { OVERLAY_ID } from './header-login.constants';
import { WIDGET_NAME } from '@sitegen/common/constants/widgets';
import { LOADING_STATE } from 'modules/loading-manager/loading-manager.constants';

import ubisoftOverlayService from 'modules/ubisoft-overlay-service/service';
import CustomLogout from './custom-logout';

import './header-login.styles.less';

export class HeaderLogin extends React.Component<IHeaderLoginProps, IHeaderLoginState> {
    constructor(props: IHeaderLoginProps) {
        super(props);

        if (props.hasTPCEnabled) {
            ubisoftOverlayService.registerLoginCallback(this.logIn);
            ubisoftOverlayService.registerLogoutCallback(this.logOut);
            ubisoftOverlayService.configure({
                env: this.props.config.envName,
                appId: this.props.config.applicationId,
                genomeId: this.props.config.genomeId,
                locale: this.props.activeLanguageCode,
            });
        }

        this.state = {
            isOverlayLoggedIn: false
        };
    }

    public componentDidMount(): void {
        this.props.hasTPCEnabled && this.loadOverlay();
    }

    public componentDidUpdate(): void {
        this.props.hasTPCEnabled && this.loadOverlay();
    }

    public logIn = (): void => {
        this.setState({
            isOverlayLoggedIn: true
        });

        if (this.props.logIn && this.props.hasTPCEnabled) {
            this.props.logIn();
        }
    };

    public logOut = (): void => {
        this.setState({
            isOverlayLoggedIn: false
        });

        if (this.props.logOut) {
            this.props.logOut();
        }
    };

    public loadOverlay = (): void => {
        const { loadingManager, loginSession } = this.props;
        const { isOverlayLoggedIn } = this.state;
        const overlayLoaded =
            loadingManager === LOADING_STATE.LOADED && (window as IWindowWithOverlay).overlayWidget;
        const isUbisoftConnectAuthenticated = loginSession && loginSession.isUbisoftConnectAuthenticated;

        if (!overlayLoaded) {
            return;
        }

        ubisoftOverlayService.init(OVERLAY_ID);

        if (isUbisoftConnectAuthenticated && !isOverlayLoggedIn) {
            ubisoftOverlayService.reInit();
        }
    };

    public renderSpinner = (): JSX.Element | null => (
        this.props.loginSession && !this.state.isOverlayLoggedIn
            ? <div className="sitegen-header-spinner" />
            : null
    );

    public renderOverlayForFR = () => <div id={OVERLAY_ID} />;

    public renderCustomLogout = (): JSX.Element | null => {
        if (!this.props.loginSession) {
            return null;
        }
        return <CustomLogout {...this.props}/>;
    };

    public renderOverlay = () => {
        const { isOverlayLoggedIn } = this.state;
        const overlayStyle = {
            display: isOverlayLoggedIn ? 'block' : 'none'
        };

        return (
            <>
                {this.renderSpinner()}
                <div id={OVERLAY_ID} style={overlayStyle} />
            </>
        );
    };

    public render() {
        const { hasTPCEnabled, config: { widgetName } } = this.props;

        if (!hasTPCEnabled) {
            return this.renderCustomLogout();
        }

        return (
            <div className="sitegen-user">
                {
                    widgetName === WIDGET_NAME.FRIENDS_REFERRAL
                        ? this.renderOverlayForFR()
                        : this.renderOverlay()
                }
            </div>
        );
    }
}

export interface IHeaderLoginProps extends ITranslationProps {
    readonly loginSession: ILoginSession;
    readonly hasTPCEnabled: boolean;
    readonly logIn?: () => void;
    readonly logOut?: () => void;
    readonly config: IConfig;
    readonly activeLanguageCode: string;
    readonly loadingManager: LOADING_STATE;
}

interface IHeaderLoginState {
    readonly isOverlayLoggedIn: boolean;
}

export default translate()(HeaderLogin);
